import { render, staticRenderFns } from "./userForm.component.vue?vue&type=template&id=158fc6e8&"
import script from "./userForm.component.vue?vue&type=script&lang=js&"
export * from "./userForm.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports